// extracted by mini-css-extract-plugin
export default {"linkContainer":"de9m48gT0RFjV7C7u8zx"};